import { AppRoutes } from '@/constants/appRoutes'
import { EUserStatus } from '@/constants/userStatus'

export const STATUS_ALLOWED_ROUTES: Record<EUserStatus, string[]> = {
  // User blocked, deleted or pending - redirect to login
  [EUserStatus.BLOCKED]: [],
  [EUserStatus.DELETED]: [],
  [EUserStatus.PENDING]: [],

  // User pending email verification
  [EUserStatus.PENDING_EMAIL_VERIFICATION]: [
    AppRoutes.registerEmailVerification,
  ],

  // User pending password setup (Payment Link flow)
  [EUserStatus.PENDING_SET_PASSWORD]: [AppRoutes.setPassword],

  // User pending motivation selection
  [EUserStatus.PENDING_MOTIVATION]: [
    AppRoutes.welcomeToSelfCheck,
    AppRoutes.motivation,
  ],

  // User pending profile update
  [EUserStatus.PENDING_SET_PERSONAL_INFO]: [AppRoutes.personalInfo],

  // User pending social media setup
  [EUserStatus.PENDING_SOCIAL_MEDIAS]: [AppRoutes.setupDigitalFootprint],

  // User pending account activation
  [EUserStatus.PENDING_ACCOUNT_ACTIVATION]: [
    AppRoutes.defaultBehaviorAndTopics,
  ],

  // Active user
  [EUserStatus.ACTIVE]: [
    // Dashboard routes
    AppRoutes.dashboard,
    AppRoutes.contactUs,
    AppRoutes.billingAndInvoices,
    AppRoutes.reports,
    AppRoutes.account,
    // Report routes
    AppRoutes.socialMediaProfile,
    AppRoutes.digitalReport,
    // Search routes
    AppRoutes.confirmSearchInfo,
    AppRoutes.editDigitalFootprint,
    AppRoutes.generatingReport,
    // Payment routes
    AppRoutes.generatingReportMock,
    AppRoutes.paymentPaywall,
    AppRoutes.paymentSuccess,
    // Impersonation check routes
    AppRoutes.impersonationConfirmInfo,
    AppRoutes.impersonationScreening,
    AppRoutes.impersonationPaywall,
    AppRoutes.impersonationPaymentSuccess,
    AppRoutes.impersonationGeneratingReport,
    AppRoutes.impersonationReport,
  ],
}

/**
 * Public routes
 */
export const PUBLIC_ROUTES = [
  AppRoutes.login,
  AppRoutes.forgotPassword,
  AppRoutes.createPassword,
  AppRoutes.forgotPaswordCheckYourInbox,
  AppRoutes.loginError,
  AppRoutes.authSuccess,
  AppRoutes.registerStart,
  AppRoutes.revealDigitalFootprint,
  AppRoutes.prospectEmailVerification,
  AppRoutes.publicPaymentPaywall,
]

/**
 * Default routes
 */
export const STATUS_DEFAULT_ROUTE: Record<EUserStatus, string> = {
  [EUserStatus.BLOCKED]: AppRoutes.login,
  [EUserStatus.DELETED]: AppRoutes.login,
  [EUserStatus.PENDING]: AppRoutes.registerEmailVerification,
  [EUserStatus.PENDING_EMAIL_VERIFICATION]: AppRoutes.registerEmailVerification,
  [EUserStatus.PENDING_SET_PASSWORD]: AppRoutes.setPassword,
  [EUserStatus.PENDING_MOTIVATION]: AppRoutes.welcomeToSelfCheck,
  [EUserStatus.PENDING_SET_PERSONAL_INFO]: AppRoutes.personalInfo,
  [EUserStatus.PENDING_SOCIAL_MEDIAS]: AppRoutes.setupDigitalFootprint,
  [EUserStatus.PENDING_ACCOUNT_ACTIVATION]: AppRoutes.defaultBehaviorAndTopics,
  [EUserStatus.ACTIVE]: AppRoutes.dashboard,
}
